import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'shared/utils/toast';

import { equipmentApi } from '../api/equipmentApi';
import { EquipmentFormValues } from '../types';

export const useCreateEquipment = () => {
  const navigate = useNavigate();
  const [tenantEmail, setTenantEmail] = useState<string | null>(null);

  useEffect(() => {
    equipmentApi.getTenantSettings().then((tenant) => {
      setTenantEmail(tenant?.email ?? null);
    });
  }, []);

  const onSubmit = async (values: EquipmentFormValues) => {
    const payload = { ...values };
    if (!payload.email_body && tenantEmail) payload.email_body = tenantEmail;

    const res = await equipmentApi.create(payload);
    if (res?.id) {
      toast.success('Strumento creato con successo');
      navigate(`../${res.id}`);
    }
  };

  return { onSubmit };
};
